import {Injectable,  Inject, PLATFORM_ID} from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class SEOService {

    constructor(private titleService: Title, private meta: Meta, @Inject(PLATFORM_ID) private readonly platformId: any) {
    }


    clearMetaTags() {
      const metaTags = document.querySelectorAll('meta[name], meta[property]');
      metaTags.forEach((tag: any) => this.meta.removeTagElement(tag));
    }

    // addMetaTag(seoData: any) {
    //     seoData.map((data: any) => {
    //         if (data.meta_type === 'default_meta') {
    //             this.meta.addTag({name: data.name, content: data.content});
    //         }

    //         if (data.meta_type === 'og') {
    //             this.meta.addTag({property: 'og:' + data.name, content: data.content});
    //         }

    //         if (data.meta_type === 'twitter') {
    //             this.meta.addTag({property: 'twitter:' + data.name, content: data.content});
    //         }

    //         if (data.meta_type === 'geo') {
    //             this.meta.addTag({property: 'geo.' + data.name, content: data.content});
    //         }

    //         if (data.meta_type === 'place') {
    //             this.meta.addTag({property: 'place:' + data.name, content: data.content});
    //         }

    //         if (data.meta_type === 'restaurant') {
    //             this.meta.addTag({property: 'restaurant:' + data.name, content: data.content});
    //         }

    //     });
    // }

    addMetaTag(seoData: any) {
      seoData.forEach((data: any) => {
        if (data.meta_type === 'default_meta') {
          this.meta.updateTag({ name: data.name, content: data.content });
        }

        if (data.meta_type === 'og') {
          this.meta.updateTag({ property: 'og:' + data.name, content: data.content });
        }

        if (data.meta_type === 'twitter') {
          this.meta.updateTag({ property: 'twitter:' + data.name, content: data.content });
        }

        if (data.meta_type === 'geo') {
          this.meta.updateTag({ property: 'geo.' + data.name, content: data.content });
        }

        if (data.meta_type === 'place') {
          this.meta.updateTag({ property: 'place:' + data.name, content: data.content });
        }

        if (data.meta_type === 'restaurant') {
          this.meta.updateTag({ property: 'restaurant:' + data.name, content: data.content });
        }
      });
    }

    public createCustomContent(schemaCodes: any) {
        if (this.platformId === 'browser') {
          const script = document.createElement('script');
          script.type = 'application/ld+json';
          script.innerHTML = schemaCodes;
          document.head.appendChild(script);
        }
      }

      public createCustomCanonical(data: any) {
        if (this.platformId === 'browser') {
          const canonicalInput = data.canonical;      
          // Remove the existing canonical tag if it exists
          const existingCanonical = document.querySelector('link[rel="canonical"]');
          if (existingCanonical) {
            existingCanonical.remove();
          }
      
          // Extract the canonical URL from the input
          let canonicalUrl = '';
          const urlRegex = /(https?:\/\/[^\s"']+)/;
          const match = canonicalInput.match(urlRegex);
      
          if (match && match[1]) {
            canonicalUrl = match[1];
          } else {
            // console.error('Invalid canonical input:', canonicalInput);
            return;
          }
      
          // Create a new canonical link element
          const linkElement = document.createElement('link');
          linkElement.setAttribute('rel', 'canonical');
          linkElement.setAttribute('href', canonicalUrl);
          document.head.appendChild(linkElement);
        }
      }
      

    setPageTitle(pageTitle: any) {
        this.titleService.setTitle(pageTitle);
    }
}
